import { ChevronRight } from "lucide-react"
import React from "react"

interface SectionHeaderProps {
  title: string
  icon?: React.ReactNode
  showChevron?: boolean
}

export function SectionHeader({ title, icon, showChevron = true }: SectionHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-3">
      <h2 className="text-sm md:text-base font-semibold truncate" style={{ color: "var(--hexa-text-primary)" }}>
        {title}
      </h2>
      {icon ? (
        icon
      ) : showChevron ? (
        <ChevronRight className="w-4 h-4 flex-shrink-0" style={{ color: "var(--hexa-purple)" }} />
      ) : null}
    </div>
  )
}
